export const enum ArticleStatusEnum {
    Active = 0,
    Disabled = 1,
}
